import MoneyIcon from '@/components/icons/MoneyIcon';
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useCurrencyStore } from '@/store/useCurrencyStore';
import { FC } from 'react';

type Props = {
	containerClasses?: string;
};

const AccountPopupCurrency: FC<Props> = ({ containerClasses }) => {
	const { currentCurrency, currencies, setCurrentCurrency } =
		useCurrencyStore();

	return (
		<Accordion
			type='single'
			collapsible
			className={cn('flex items-center gap-2 text-sm', containerClasses)}>
			<AccordionItem
				value='item-1'
				className='w-full'>
				<AccordionTrigger iconClassName='right-3'>
					<Button
						variant='ghost'
						className={
							'w-full p-3 justify-start gap-2.5 stroke-popover'
						}>
						<MoneyIcon />
						<span>{`${currentCurrency} - ${currentCurrency && currencies[currentCurrency]}`}</span>
					</Button>
				</AccordionTrigger>
				<AccordionContent className='mt-2 flex flex-col gap-2'>
					{Object.entries(currencies).map(([key, value]) => (
						<AccordionTrigger iconClassName='hidden'>
							<Button
								variant='ghost'
								key={key}
								className='w-full p-3 flex items-center justify-between gap-2.5 rounded-semi-xl hover:bg-popover-50 active:bg-popover-100'
								onClick={() =>
									setCurrentCurrency(
										key as keyof typeof currencies,
									)
								}>
								{`${key} - ${value}`}
								<div
									className={cn(
										'size-4 ml-auto border-popover-1000 rounded-full transition-all',
										currentCurrency === key
											? 'border-4'
											: 'border',
									)}
								/>
							</Button>
						</AccordionTrigger>
					))}
				</AccordionContent>
			</AccordionItem>
		</Accordion>
	);
};

export default AccountPopupCurrency;
